import { memo, useContext } from 'react';
import { useEpisodeLaunchComparisonQuery } from '@/services/revenueApi';
import type { LaunchWindowDays } from '@/types/content';
import LaunchInfoBox from './LaunchInfoBox';
import LaunchWindowControls from './LaunchWindowControls';
import PostLaunchComparisonChart from './PostLaunchComparisonChart';
import { SelectableMetricsContext } from '../PerformanceTable/SelectableMetricsContext';
import type { ContentQueryDataSources } from '../performanceCardUrlBuilders';

interface PostLaunchComparisonProps {
  windowDays: LaunchWindowDays;
  onWindowChange: (windowDays: LaunchWindowDays) => void;
  isSynced: boolean;
  dataSource: ContentQueryDataSources;
}

/**
 * Container that assembles the launch-window controls and post-launch comparison chart.
 * Fetches comparison data via `useEpisodeLaunchComparisonQuery` and passes it down.
 */
const PostLaunchComparison = memo(
  ({ windowDays, onWindowChange, isSynced, dataSource }: PostLaunchComparisonProps) => {
    const { selectedItems } = useContext(SelectableMetricsContext);

    const data = useEpisodeLaunchComparisonQuery(selectedItems, windowDays, isSynced, dataSource);

    return (
      <>
        <LaunchWindowControls windowDays={windowDays} onWindowChange={onWindowChange} />
        <PostLaunchComparisonChart
          selectedItems={selectedItems}
          data={data}
          windowDays={windowDays}
        />
        <LaunchInfoBox windowDays={windowDays} />
      </>
    );
  }
);

export default PostLaunchComparison;
